const CHAT_WIDGET_SCRIPT_ID = 'scale2rev-chat-widget';

export function loadChatWidget() {
  if (document.getElementById(CHAT_WIDGET_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = CHAT_WIDGET_SCRIPT_ID;
  script.src = 'https://scale2rev.com/widget/widget.js';
  script.dataset.tenantId = 'a95843dc-7795-46ef-9571-6699f73f89bf';
  script.dataset.siteId = 'd6866a13-3790-42da-89dd-5e3bd621d7f1';
  document.body.appendChild(script);
}
